export const mostSearched = [
  '7',
  '33',
  '44',
  '52',
  '55',
  '56',
  '61',
  '62',
  '63',
  '65',
  '67',
  '69',
  '72',
  '75',
  '76',
  '77',
  '82',
  '87',
  '88',
  '95',
  '97',
  '99',
  '101',
  '1971'
]

export const CHEAP_NEW_VEHICLE_PRICE = 5000

export const VEHICLE_SPECS_CONTEXT = {
  HIRED_MAKES: 'hired-makes',
  MAKE: 'makes',
  MODEL: 'models',
  MODELS_VERSION: 'models-version',
  VERSION: 'versions'
}

export const VEHICLE_EXTRAS_FIELD = {
  COLOR: 'color',
  EQUIPMENT: 'equipment'
}

export const VEHICLE_SPEC_PARAMS = {
  MANUAL_ITEMS: {},
  MARKETED_ITEMS: {}
}

export const HAS_JATO = false

export const MAKE_ID_LOGOS_MAP = {}
